import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7e10512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action-buttons" }

import { ref, reactive, unref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElButton, ElMessage, ElTag } from 'element-plus';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useDictionary } from '@/store/dictionary.store';
import { formatTools } from '@/utils/index';
import { GetContractNotDraftApi } from '@/apis/contract/contract.api';
import { GetTradeCacheListApi } from '@/apis/basics/trade.api';
import InvolvedUsersDrawer from './components/involvedUsers.vue';
import AuditLocusDrawer from './components/auditlocus.vue';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';
import { useLocaleStoreWithOut } from '@/store/locale';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();
const localeStore = useLocaleStoreWithOut();

const { push } = useRouter();
const { getName, getSelectList } = useDictionary();
const { fDateTime, fDate, fAmount } = formatTools();

const auditLocusDrawerRef = ref<InstanceType<typeof AuditLocusDrawer>>();

const involvedUsersDrawerRef = ref<InstanceType<typeof InvolvedUsersDrawer>>();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetContractNotDraftApi,
	response: { data: 'data', total: 'total' },
});

const state = reactive({
	loading: false,
	disabledPartyb: false,
	parytBList: [] as any[],
	search: {} as any,
	paged: { current: 1, page_size: 20 },
});

const load = {
	/* 获取相对方数据 */
	getPartybList: async () => {
		state.disabledPartyb = true;
		const { succeeded, errors, data } = await GetTradeCacheListApi();
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			state.parytBList = (data || []).map((pb: any) => {
				return { label: pb.name, value: pb.id };
			});
		}
		state.disabledPartyb = false;
	},
};

/* 数据Table绑定设置 */
const tabColumns = reactive<any[]>([
	{ field: 'status', label: t('contractList.table.status', '状态'), columnWidth: '100', align: 'center' },
	{ field: 'no', label: t('contractList.table.contractNo', '合同编号'), columnWidth: '120' },
	{ field: 'name', label: t('contractList.table.contractName', '合同名称'), columnWidth: '200' },
	{ field: 'plan_a_name', label: t('contractList.table.ourParty', '我方主体'), columnWidth: '200' },
	{ field: 'counterpart_name', label: t('contractList.table.counterpart', '相对方'), columnWidth: '200' },
	{ field: 'category_name', label: t('contractList.table.contractCategory', '合同分类'), columnWidth: '300' },
	{ field: 'time_limit', label: t('contractList.table.contractTerm', '合同期限'), columnWidth: '200', align: 'center' },
	{ field: 'contract_amount', label: t('contractList.table.totalAmount', '合同金额'), columnWidth: '100', align: 'right' },
	{ field: 'contract_source', label: t('contractList.table.signingSource', '签订来源'), columnWidth: '100', align: 'center' },
	{ field: 'create_user', label: t('contractList.table.creator', '创建人'), columnWidth: '120', align: 'center' },
	{ field: 'created_time', label: t('contractList.table.createdDate', '创建时间'), columnWidth: '120', align: 'center' },
	{ field: 'action', label: t('contractList.table.action', '操作'), columnWidth: localeStore.getCurrentLocale.lang === 'zh-cn' ? '200' : '400', fixed: 'right', align: 'center' },
]);

const actions = {
	search: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
	reSetSearch: () => {
		state.search = {};
		methods.resetParams(state.search);
	},
	preview: (row: any) => {
		push({ path: `/contracts/previews`, query: { contractId: `${row.id}` } });
	},
	/* 审批流程轨迹 */
	locus: (row: any) => {
		unref(auditLocusDrawerRef)?.showDrawer(row.id, row.created_user_id);
	},
	/* 参与者 */
	involvedUsers: (row: any) => {
    // eslint-disable-next-line no-mixed-spaces-and-tabs
    unref(involvedUsersDrawerRef)?.showDrawer2(row.id);
	}
};

onMounted(async () => {
	tableObject.pageSize = 20;
	actions.search();

	load.getPartybList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "naver",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(state).search,
          ref: "queryFormRef",
          size: "small",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contractList.form.contractNo', '合同编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).search.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.no) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contractList.form.contractName', '合同名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).search.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('contractList.form.counterpart', '相对方')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  modelValue: _unref(state).search.counterpart_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).search.counterpart_id) = $event)),
                  disabled: _unref(state).disabledPartyb,
                  clearable: "",
                  filterable: "",
                  options: _unref(state).parytBList,
                  class: "w100",
                  placeholder: _unref(t)('contractList.form.selectCounterpart', '请选择相对方'),
                  onChange: actions.search
                }, null, 8, ["modelValue", "disabled", "options", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('contractList.form.contractStatus', '状态')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: _unref(state).search.status,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).search.status) = $event)),
                  placeholder: _unref(t)('contractList.form.statusPlaceholder', '状态'),
                  onChange: actions.search
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectList)('contract_status', true), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSetSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.reset', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      icon: "Search",
                      onClick: actions.search
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "naver",
      class: "mgt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[4] || (_cache[4] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(fDateTime)(row.created_time)), 1)
          ]),
          status: _withCtx(({ row }) => [
            _createVNode(_unref(ElTag), { size: "small" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getName)('contract_status', row.status)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          contract_amount: _withCtx(({ row }) => [
            (row.amount_flag == 'Y')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(fAmount)(row.contract_amount)), 1)
                ], 64))
              : (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 1,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('contractList.table.noAmountContract', '无金额合同')), 1)
                  ]),
                  _: 1
                }))
          ]),
          time_limit: _withCtx(({ row }) => [
            (row.contract_limit == 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(fDate)(row.begin_day)) + " ~ " + _toDisplayString(_unref(fDate)(row.end_day)), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_unref(fDate)(row.begin_day)) + " ~ " + _toDisplayString(_unref(fDate)(row.end_day, _unref(t)('contractList.table.noFixedTerm', '无固定期限'))), 1)
                ], 64))
          ]),
          contract_source: _withCtx(({ row }) => [
            _createVNode(_unref(ElTag), { size: "small" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getName)('contract_source', row.contract_source)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          action: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(ElButton), {
                type: "primary",
                link: "",
                size: "small",
                onClick: ($event: any) => (actions.preview(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.detail', '详细')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_unref(ElButton), {
                type: "danger",
                link: "",
                size: "small",
                onClick: ($event: any) => (actions.involvedUsers(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.participants', '参与者')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_unref(ElButton), {
                type: "warning",
                link: "",
                size: "small",
                onClick: ($event: any) => (actions.locus(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('contractList.buttons.trace', '轨迹')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }),
    _createVNode(AuditLocusDrawer, {
      ref_key: "auditLocusDrawerRef",
      ref: auditLocusDrawerRef
    }, null, 512),
    _createVNode(InvolvedUsersDrawer, {
      ref_key: "involvedUsersDrawerRef",
      ref: involvedUsersDrawerRef
    }, null, 512)
  ], 64))
}
}

})